import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, pipe } from "rxjs";
import { map } from "rxjs/operators";
import {
    Bodytype,
    Characteristic,
    EurocodeRecord,
    Glassposition,
    Glasstint,
    Glasstype,
    ManufacturerWizard,
    Model,
    ModelWizard,
} from "src/app/argic/domain/eurocode";
import { LoginService } from "src/app/login/login.service";
import { AcType } from "src/app/models/ac-type";
import { Manufacturer } from "src/app/models/manufacturer";
import { environment } from "src/environments/environment";
import { EurocodeChangeRequest } from "../domain/eurocodechangerequest";
import { EurocodeHistoric } from "../domain/eurocodehistoric";


/*

        var response = new
        {
            Page = page,
            PageSize = pageSize,
            TotalRecords = totalRecords,
            TotalPages = totalPages,
            Data = models
        };

*/

interface PagedResponse<T> {
    Page: number;
    PageSize: number;
    TotalRecords: number;
    TotalPages: number;
    Data: T[];
}

@Injectable({
    providedIn: "root",
})
export class AdminService {
    constructor(private http: HttpClient, private loginService: LoginService) {}


    /* DASHBOARD COUNTS*/

    // getCountByStatus(status: string): Observable<string> {
    //     let params = new HttpParams().set('status', status);
    //     return this.http.get<string>(`${environment.apiWizardUrl}Eurocodes/GetCountByStatus`, {
    //         params,
    //         withCredentials: true,
    //     });
    // }
    // getTempModel(): Observable<string> {
    //     return this.http.get<string>(`${environment.apiWizardUrl}Eurocodes/GetTempModel`, {
    //         withCredentials: true,
    //     });
    // }
    // getTempRef(): Observable<string> {
    //     return this.http.get<string>(`${environment.apiWizardUrl}Eurocodes/GetTempRef`, {
    //         withCredentials: true,
    //     });
    // }


    /* 
    -------------------------------------
    EUROCODES
    -------------------------------------
    */
    // getEurocodes(page,pageSize, query, status): Observable<PagedResponse<EurocodeRecord>>{
    //     let params = new HttpParams()
    //     .set('page', page.toString())
    //     .set('pageSize', pageSize.toString())
    //     .set('query', query)
    //     .set('status', status);
    //     return this.http
    //         .get<PagedResponse<EurocodeRecord>>(
    //             environment.apiWizardUrl +
    //                 "Eurocodes/getCodesPaged"/* +
    //                 JSON.stringify(searchdata)*/,          {
    //                     params,
    //             withCredentials: true,
    //         }
    //         )
    //         .pipe(
    //             map((l) => {
    //                 l.Data.forEach((data) => {
    //                     data.oem = data.oem;
    //                     data.sameAs = data.sameAs;

    //                     data.fulldescription = data.des ?? "";
    //                     if (data.char ?? false)
    //                         data.fulldescription += "\n" + (data.char ?? "");
    //                     if (data.modif ?? false)
    //                         data.fulldescription += "\n" + (data.modif ?? "");
    //                     if (data.info ?? false)
    //                         data.fulldescription += "\n" + (data.info ?? "");

    //                     data.fulldescription = data.fulldescription.toUpperCase().trim();
    //                 });
    //                 return l;
    //             })
    //         );
    // }
    /* 
    -------------------------------------
    MODELS
    -------------------------------------
     */
    // getModels(): Observable<Model[]> {
    //     return this.http.get<Model[]>(environment.apiWizardUrl + "Models/",
    //         {
    //             withCredentials: true,
    //         }
    //     );
    // }
    
    // getModelsPaged(page,pageSize, query): Observable<PagedResponse<ModelWizard>> {
        
    // let params = new HttpParams()
    // .set('page', page.toString())
    // .set('query',query)
    // .set('pageSize', pageSize.toString());
    //     return this.http.get<PagedResponse<ModelWizard>>(`${environment.apiWizardUrl}ModelsPaged`,
    //         {
    //         params,    
    //         withCredentials: true,
    //         }
    //     );
    // }

    // getModelById(id: number): Observable<ModelWizard> {
    //     return this.http.get<ModelWizard>(`${environment.apiWizardUrl}api/Models/${id}`, {
    //       withCredentials: true,
    //     });
    //   }
    
    //   createModel(model: ModelWizard): Observable<ModelWizard> {
    //     return this.http.post<ModelWizard>(`${environment.apiWizardUrl}api/Models`, model, {
    //       withCredentials: true,
    //     });
    //   }
    
    //   updateModel(id: number, model: ModelWizard): Observable<ModelWizard> {
    //     return this.http.post<ModelWizard>(`${environment.apiWizardUrl}api/Models/update/${id}`, model, {
    //       withCredentials: true,
    //     });
    //   }



    /* 
    -------------------------------------
    Manufacturers
    -------------------------------------
    */
      
    // getManufacturersPaged(page: number, pageSize: number, query:string): Observable<PagedResponse<ManufacturerWizard>> {
    //     let params = new HttpParams()
    //         .set('page', page.toString())
    //         .set('pageSize', pageSize.toString())
    //         .set('query', query);
    //     return this.http.get<PagedResponse<ManufacturerWizard>>(`${environment.apiWizardUrl}api/ManufacturersPaged`, {
    //         params,
    //         withCredentials: true,
    //     });
    // }

    // getManufacturerById(id: number): Observable<ManufacturerWizard> {
    //     return this.http.get<ManufacturerWizard>(`${environment.apiWizardUrl}api/Manufacturers/${id}`, {
    //         withCredentials: true,
    //     });
    // }

    // createManufacturer(manufacturer: ManufacturerWizard): Observable<ManufacturerWizard> {
    //     return this.http.post<ManufacturerWizard>(`${environment.apiWizardUrl}api/Manufacturers`, manufacturer, {
    //         withCredentials: true,
    //     });
    // }

    // updateManufacturer(id: number, manufacturer: ManufacturerWizard): Observable<ManufacturerWizard> {
    //     return this.http.post<ManufacturerWizard>(`${environment.apiWizardUrl}api/Manufacturers/update/${id}`, manufacturer, {
    //         withCredentials: true,
    //     });
    // }

   
    /* 
    -------------------------------------
    Modifications
    -------------------------------------
    */

    // getHistorics(eurocode: string): Observable<EurocodeHistoric[]> {
    //     return this.http
    //         .get<EurocodeHistoric[]>(
    //             environment.apiWizardUrl +
    //                 "EurocodeHistoric/QueryEurocode?eurocode=" +
    //                 eurocode,
    //             {
    //                 withCredentials: true,
    //             }
    //         )
    //         .pipe(
    //             map((x) => {
    //                 let data = x;
    //                 data.forEach((x) => {
    //                     x.ParsedChangeDate = new Date(
    //                         parseInt(
    //                             x.ChangeDate.replace("/Date(", "").replace(
    //                                 ")/",
    //                                 ""
    //                             ),
    //                             10
    //                         )
    //                     );
    //                     let langid = this.loginService.userprofile.languageId;
    //                     let langfield;
    //                     switch (langid) {
    //                         case 1:
    //                             langfield = "Descr_EN";
    //                             break;
    //                         case 2:
    //                             langfield = "Descr_DE";
    //                             break;
    //                         case 3:
    //                             langfield = "Descr_FR";
    //                             break;
    //                         case 4:
    //                             langfield = "Descr_IT";
    //                             break;
    //                         case 5:
    //                             langfield = "Descr_ES";
    //                             break;
    //                         case 6:
    //                             langfield = "Descr_NL";
    //                             break;
    //                     }
    //                     x.Description = x[langfield];
    //                     if (x.Description == null || x.Description.length == 0)
    //                         x.Description = x.Descr_EN;
    //                 });
    //                 return data;
    //             })
    //         );
    // }

    // getChangeRequests(eurocode: string): Observable<EurocodeChangeRequest[]> {
    //     return this.http
    //         .get<EurocodeChangeRequest[]>(
    //             environment.apiWizardUrl +
    //                 "EurocodeHistoric/ChangeRequests?eurocode=" +
    //                 eurocode,
    //             {
    //                 withCredentials: true,
    //             }
    //         )
    //         .pipe(
    //             map((x) => {
    //                 let data = x;
    //                 data.forEach((x) => {
    //                     if (
    //                         x.HistoricDate != null &&
    //                         x.HistoricDate.toLowerCase() != "null"
    //                     )
    //                         x.ParsedHistoricDate = new Date(
    //                             parseInt(
    //                                 x.HistoricDate.replace(
    //                                     "/Date(",
    //                                     ""
    //                                 ).replace(")/", ""),
    //                                 10
    //                             )
    //                         );
    //                 });
    //                 return data;
    //             })
    //         );
    // }

    // getFiles(eurocode: string): Observable<EurocodeHistoric[]> {
    //     return this.http.get<EurocodeHistoric[]>(
    //         environment.apiWizardUrl + "Upload/Files/" + eurocode,
    //         {
    //             withCredentials: true,
    //         }
    //     );
    // }

    //Calls to REST API (migrate to MVC later)
    // getAcTypes(): Observable<AcType[]> {
    //     return this.http.get<AcType[]>(environment.apiUrl + "api/Actypes");
    // }

   
}
